import { FindTwoInLine, RandomMove } from "./MiscGameFunctions";


function ComputerMoveMedium(squares) {

    let desiredMove = -1;

    // if we are about to win we need to place the third "O"
    desiredMove = FindTwoInLine("O", squares);
    if (desiredMove > -1) {
        return desiredMove;
    }

    // if the human is about to win we need to block them
    desiredMove = FindTwoInLine("X", squares);
    if (desiredMove > -1) {
        return desiredMove;
    }
    
    // If this is after the first human move
    if (NumberOfSquaresFilled(squares) === 1) {
      desiredMove = ComputerFirstMove(squares) 
    };

    // If this is after the second human move
    if (NumberOfSquaresFilled(squares) === 3) {
       desiredMove = ComputerSecondMove(squares);
    }

    // Otherwise, look at the board and find a random empty spot anywhere
      if (desiredMove === -1) { desiredMove = RandomMove(squares) };
    return desiredMove;
}; // end of ComputerMoveMedium

function ComputerFirstMove(squares) {
    const squaresFilledByHuman = PositionsOfPlayerSquares("X", squares);

       // if it is a corner, take the center
       if (
        (squaresFilledByHuman.includes("0")) ||
        (squaresFilledByHuman.includes("2")) ||
        (squaresFilledByHuman.includes("6")) ||
        (squaresFilledByHuman.includes("8"))
    ) {
        return 4;
    }

    // if it is the center, take a random corner
    if (squaresFilledByHuman.includes("4")) {
        return RandomCorner();
    };

    // Edge processing:
    if (
        (squaresFilledByHuman.includes("1")) ||
        (squaresFilledByHuman.includes("3")) 
    ) {
        return 0;
    }
    if (squaresFilledByHuman.includes("5")) {return 2}
    if (squaresFilledByHuman.includes("7")) {return 1}
}

function ComputerSecondMove(squares) {
    const squaresFilledByHuman = PositionsOfPlayerSquares("X", squares);
    let desiredMove = -1;

if (squaresFilledByHuman === "32") { desiredMove = IfSquareBlank(squares, 0) }
if (squaresFilledByHuman === "16") { desiredMove = IfSquareBlank(squares, 0) }

if (squaresFilledByHuman === "18") { desiredMove = IfSquareBlank(squares, 2) }
if (squaresFilledByHuman === "05") { desiredMove = IfSquareBlank(squares, 2) }

if (squaresFilledByHuman === "07") { desiredMove = IfSquareBlank(squares, 6) }
if (squaresFilledByHuman === "38") { desiredMove = IfSquareBlank(squares, 6) }

if (squaresFilledByHuman === "27") { desiredMove = IfSquareBlank(squares, 8) }
if (squaresFilledByHuman === "56") { desiredMove = IfSquareBlank(squares, 8) }

if (squaresFilledByHuman === "48") { desiredMove = IfSquareBlank(squares, 2) }

if (squaresFilledByHuman === "24") { desiredMove = IfSquareBlank(squares, 8) }

if (squaresFilledByHuman === "46") { desiredMove = IfSquareBlank(squares, 0) }

if (squaresFilledByHuman === "04") { desiredMove = IfSquareBlank(squares, 6) }

if (squaresFilledByHuman === "13" || squaresFilledByHuman === "37" ||
    squaresFilledByHuman === "57" || squaresFilledByHuman === "15" )
  { desiredMove = IfSquareBlank(squares, 4) }

return desiredMove;
} 

function IfSquareBlank(squares, testSquare) {
    return(SquareIsBlank(squares, testSquare)) ? testSquare : -1;
}

function RandomOneToFour() {
    return Math.ceil( Math.random() * 4);
}

function RandomCorner() {
    let randomNumber = RandomOneToFour();
    if (randomNumber === 1) return 0;
    if (randomNumber === 2) return 2;
    if (randomNumber === 3) return 6;
    if (randomNumber === 4) return 8;
}

function NumberOfSquaresFilled(squares) {
    let numberOfSquaresFilled = 0;
    for (const square of squares) {
        if (square !== null)
        numberOfSquaresFilled++;
    }
    return numberOfSquaresFilled;
}

function PositionsOfPlayerSquares(player, squares) {
    let currentSquare = 0;
    let positions = "";
    while (currentSquare < 9) {
        if(squares[currentSquare] === player)
        positions = positions + currentSquare;
        currentSquare++;
    }
    return positions;
}

function SquareIsBlank(squares, squareToTest) {
    if(squares[squareToTest] === null) {
        return true;
    } else {
        return false;
    }
}

export default ComputerMoveMedium;
